import { NavLink } from "react-router-dom";
import { FaHome, FaEnvelope, FaBook, FaCalendar, FaBell } from "react-icons/fa";
import { useState } from "react";
import "./student.css";

const StudentSidebar = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {
    name: "Student",
  };

  const initials = user.name
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <>
      <nav className="premium-navbar">

        {/* LEFT BRAND */}
        <div className="brand-box">
          <div className="logo-box">ॐ</div>
          <div className="brand-text">
            <div className="brand-title">
              GURUKRUPA PLACEMENT EDUCATION SOLUTIONS
            </div>
            <div className="brand-sub">
              An International Brand • Serving The People
            </div>
          </div>
        </div>

        {/* CENTER NAV */}
        <div className="nav-center">
          <NavLink to="/student/dashboard" className="nav-pill">
            <FaHome /> <span>Dashboard</span>
          </NavLink>

          <NavLink to="/student/messages" className="nav-pill">
            <FaEnvelope /> <span>Messages</span>
          </NavLink>

          <NavLink to="/student/courses" className="nav-pill">
            <FaBook /> <span>Courses</span>
          </NavLink>

          <NavLink to="/student/schedule" className="nav-pill">
            <FaCalendar /> <span>Schedule</span>
          </NavLink>
        </div>

        {/* RIGHT USER */}
        <div className="nav-right">
          <div className="bell">
            <FaBell />
          </div>

          <div className="user-pill">
            <div className="avatar">{initials}</div>
            <span>{user.name}</span>
          </div>
        </div>

      </nav>

      {/* SUB BAR */}
      <div className="sub-bar">
        Student Portal • Batch 2025–26 • Placement Track
      </div>
    </>
  );
};

export default StudentSidebar;